import React, { forwardRef, useImperativeHandle, useState } from "react";

// Funzione per costruire l'albero gerarchico
const buildTree = (data) => {
  const map = {};
  const roots: any = [];

  data.forEach((item) => {
    map[item.id] = { ...item, children: [] };
  });

  data.forEach((item) => {
    if (item.parent) {
      map[item.parent]?.children.push(map[item.id]);
    } else {
      roots.push(map[item.id]);
    }
  });

  return roots;
};

const TreeCheckboxWidget = forwardRef(
  ({ data, onSelectionChange }: any, ref) => {
    const [checkedItems, setCheckedItems] = useState({});

    const handleCheck = (id, isChecked) => {
      const updatedCheckedItems = { ...checkedItems };

      // Funzione ricorsiva per propagare lo stato ai figli
      const propagateState = (nodeId, value) => {
        updatedCheckedItems[nodeId] = value;
        treeDataMap[nodeId]?.children.forEach((child) =>
          propagateState(child.id, value)
        );
      };

      // Selezione del nodo (e dei figli, se applicabile)
      propagateState(id, isChecked);

      // Se un figlio viene deselezionato, il genitore non deve essere selezionato
      const updateParentState = (nodeId) => {
        const parentId = Object.keys(treeDataMap).find((key) =>
          treeDataMap[key].children.some((child) => child.id === nodeId)
        );
        if (parentId) {
          const parentChildren = treeDataMap[parentId].children;
          const allChildrenChecked = parentChildren.every(
            (child) => updatedCheckedItems[child.id]
          );
          updatedCheckedItems[parentId] = allChildrenChecked;
          updateParentState(parentId); // Ricorsivamente aggiorna i genitori
        }
      };

      updateParentState(id);

      // Aggiorna lo stato visivo
      setCheckedItems(updatedCheckedItems);

      // Filtra i nodi per la callback
      const selectedNodes = Object.keys(updatedCheckedItems)
        .filter((key) => updatedCheckedItems[key])
        .map((key) => treeDataMap[key]);

      const filteredNodes = filterSelectedNodes(selectedNodes);

      // Chiama la callback con i soli `iso` filtrati
      onSelectionChange(filteredNodes.map((node) => node.iso));
    };

    // Funzione per filtrare i nodi selezionati
    const filterSelectedNodes = (nodes) => {
      const selectedSet = new Set(nodes.map((node) => node.id));
      return nodes.filter(
        (node) =>
          // Include solo i nodi senza genitori già selezionati
          !Object.keys(treeDataMap).some(
            (parentId) =>
              selectedSet.has(parentId) &&
              treeDataMap[parentId]?.children.some(
                (child) => child.id === node.id
              )
          )
      );
    };

    // Funzione per costruire l'albero in modo ricorsivo
    const renderTree = (nodes) => (
      <li key={nodes.id}>
        <label>
          <input
            type="checkbox"
            checked={checkedItems[nodes.id] || false}
            onChange={(e) => handleCheck(nodes.id, e.target.checked)}
          />
          {nodes.name}
        </label>
        {nodes.children && nodes.children.length > 0 && (
          <ul>{nodes.children.map((child) => renderTree(child))}</ul>
        )}
      </li>
    );

    const treeData = buildTree(data);

    // Creare una mappa per accedere velocemente ai nodi
    const treeDataMap = {};
    const flattenTree = (nodes) => {
      nodes.forEach((node) => {
        treeDataMap[node.id] = node;
        if (node.children && node.children.length > 0) {
          flattenTree(node.children);
        }
      });
    };
    flattenTree(treeData);

    useImperativeHandle(
      ref,
      () => ({
        reset: () => {
          setCheckedItems({});
          onSelectionChange([]);
        },
      }),
      [onSelectionChange]
    );

    return (
      <div style={{ fontSize: "0.7vw" }}>
        <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
          {treeData.map((node) => renderTree(node))}
        </ul>
      </div>
    );
  }
);
export default TreeCheckboxWidget;
